module.exports = __webpack_public_path__ + "img/download.6930dbd0.png";